import * as React from "react";
import times from "lodash/times";
import { Table, TableRow, TableCell } from "./Table";
import Placeholder from "./Placeholder";

const columnSizing = "1fr 1fr";

const UsersListPlaceholder = ({ users, match, ...otherProps }) => {
  const renderUser = iter => {
    return (
      <TableRow key={`user-placeholder-${iter}`} columns={columnSizing}>
        <TableCell>
          <div style={{ flex: "1 0 auto" }}>
            <Placeholder style={{ maxWidth: 200 }} />
            <Placeholder style={{ maxWidth: 400 }} />
          </div>
        </TableCell>
        <TableCell>
          <Placeholder style={{ maxWidth: 100 }} />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Table noSideBorders {...otherProps}>
      <TableRow header columns={columnSizing}>
        <TableCell>Name &amp; Email</TableCell>
        <TableCell>Role</TableCell>
      </TableRow>
      {times(15, renderUser)}
    </Table>
  );
};

export default UsersListPlaceholder;



// WEBPACK FOOTER //
// ./src/components/UsersListPlaceholder.js